"use strict";const e=require("./Slider.js");module.exports=e;
//# sourceMappingURL=index.js.map
